import { Component, OnInit } from '@angular/core';
import { PraService } from '../services/pra.service';
import { AuthenticationService } from '../services/authentication.service';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { GridOptions } from 'ag-grid';
import { ChildSearchByEidComponent } from '../pra-search-by-eid/child-request-grid/child-request-grid.component'
import { GridDataModel } from '../pra-search-by-eid/dataModel';
//Format Time with momentJS
import * as moment from 'moment'
//lodash
import * as _ from "lodash";

@Component({
  selector: 'app-pra-search-by-eid',
  templateUrl: './pra-search-by-eid.component.html',
  styleUrls: ['./pra-search-by-eid.component.css']
})
export class PraSearchByEidComponent implements OnInit {

  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Current User
  currentUser: any;
  opsId: any = null;

  //Form Variables
  eid: number;
  params: any;

  //Lists
  praRequestsList: any[];
  gridList: Array<GridDataModel> = new Array<GridDataModel>();
  excelList: any[];

  //Grid
  private gridApi;
  private gridColumnApi;
  public gridOptions: GridOptions;

  //Flags
  validEid: boolean = false;
  showGrid: boolean = false;
  showExcelButton: boolean = false;

  //Error handling variables
  consentErrMsg = '';

  constructor(
    private PraService: PraService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.gridOptions = <GridOptions>{
    };
    this.gridOptions.columnDefs = this.requestHeaders();
    this.gridOptions.context = {
      componentParent: this
    };
    this.gridOptions.getRowStyle = function (params) {
      if (params.data.RequestStatusCode == 'Cancelled') {
        return { background: '#f8ea70' };
      }
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.params = params;
    })

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (typeof this.params.EID !== 'undefined') {
      this.eid = this.params.EID;
      this.getPraRequests();
    }
  }


  //Grid headers
  private requestHeaders() {
    return [
      {
        headerName: '', field: 'Value', width: 85, colId: "params",
        cellRendererFramework: ChildSearchByEidComponent
      },
      {
        headerName: "Date Created",
        field: "DateCreated",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Selected Week",
        field: "SelectedWeek",
        width: 122,
        colId: "params",
      },
      {
        headerName: "Request ID",
        field: "PRARequestID",
        width: 100,
        colId: "params",
      },
      { headerName: "EID", field: "EmployeeID", width: 80, colId: "params" },
      {
        headerName: "Name",
        field: "EmployeeName",
        width: 132,
        colId: "params",
      },
      {
        headerName: "Status",
        field: "RequestStatusCode",
        width: 90,
        colId: "params",
      },
      {
        headerName: "Total Hours",
        field: "Total",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Home Store",
        field: "HomeStore",
        width: 110,
        colId: "params",
      },
      {
        headerName: "Work Store",
        field: "WorkStoreID",
        width: 110,
        colId: "params",
      },
      { headerName: "Home State", field: "State", width: 110, colId: "params" },
      {
        headerName: "Process Level",
        field: "RegionCode",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Comments",
        field: "Comments",
        width: 120,
        colId: "params",
      }
    ]
  }

  // Request List Details Button
  public methodFromParent(id) {
    console.log(id);
    this.router.navigate(['./view-adjustment-records/pra-details'], {
      queryParams: {
        ID: id,
        searchType: 'eid'
      }
    })
  }

  getPraRequests() {
    if (this.eid == null || this.eid == undefined || this.eid.toString().length !== 7) {
      this.validEid = true;
      this.showGrid = false;

    } else {
      this.gridList = [];
      this.loading = true;
      this.validEid = false;
      this.showGrid = true;
      this.PraService.getPRARequestsEID(
        this.currentUser.userId,
        this.currentUser.employeeId,
        this.currentUser.payrolladmin,
        this.currentUser.opsLevel,
        null,
        null,
        null,
        null,
        null,
        this.eid
      ).pipe(first())
        .subscribe(
          data => {
            this.loading = false;
            data.reverse();

            for (let index in data) {
              this.gridList.push(new GridDataModel(data[index]));
            }

            //Make a new list to remove Business Date and Daily Total
            let newList: any = []
            for (let index in this.gridList) {
              newList.push({
                DateCreated: this.gridList[index].DateCreated,
                SelectedWeek: this.gridList[index].SelectedWeek,
                PRARequestID: this.gridList[index].PRARequestID,
                EmployeeID: this.gridList[index].EmployeeID,
                EmployeeName: this.gridList[index].EmployeeName,
                RequestStatusCode: this.gridList[index].RequestStatusCode,
                Total: this.gridList[index].Total,
                HomeStore: this.gridList[index].HomeStore,
                WorkStoreID: this.gridList[index].WorkStoreID,
                State: this.gridList[index].State,
                RegionCode: this.gridList[index].RegionCode,
                Comments: this.gridList[index].Comments
              });
            }

            console.log(data);
            this.praRequestsList = _.uniqWith(newList, _.isEqual);
            this.excelList = this.gridList;
            console.log(this.gridList);

            //show Excel button of PRA list shows records
            if (this.praRequestsList.length > 0) {
              this.showExcelButton = true;
            }

          },
          error => {
            this.loading = false;
            if (error.status === 401) {
              this.authenticationService.logout();
              this.router.navigate(['/login']);
            } else {
              this.consentErrMsg = 'Something went wrong, please contact your administrator:' + error;
            }
          })
    }

  }

  exportAsXLSX() {
    //Create data model for excel sheet
    let excelList = [];
    for (let index in this.excelList) {
      excelList.push({
        DateCreated: this.excelList[index].DateCreated,
        SelectedWeek: this.excelList[index].SelectedWeek,
        RequestID: this.excelList[index].PRARequestID,
        EID: this.excelList[index].EmployeeID,
        Name: this.excelList[index].EmployeeName,
        Status: this.excelList[index].RequestStatusCode,
        BusinessDate: this.excelList[index].BusinessDate,
        DailyTotalHours: this.excelList[index].DailyTotalHours,
        TotalHours: this.excelList[index].Total,
        HomeStore: this.excelList[index].HomeStore,
        WorkStore: this.excelList[index].WorkStoreID,
        HomeState: this.excelList[index].State,
        ProcessLevel: this.excelList[index].RegionCode,
        Comments: this.excelList[index].Comments
      });
    }
    console.log(excelList);

    this.PraService.exportAsExcelFile(excelList, 'PraList' + moment().format("YYYY-MM-DD"));
  }

}
